import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PAGE_PATHS } from '../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/relations/relations/')({
  validateSearch: zodValidator(withDefaults(schema.RELATIONS, defaultFilter)),
  search: {
    middlewares: [stripSearchParams(defaultFilter)],
  },
  beforeLoad: ({ context, preload }) => {
    const path = PAGE_PATHS.RELATIONS;
    const isAllowed = context.userPermissions.hasAllowedPermission({ path });
    context.validatePermissions({ isAllowed, preload });
  },
});
